<template>
	<div>
		<!-- 遮罩层 -->
		<div v-if="visible" class="vip-mask" @click.self="closeDialog">
			<!-- 弹窗容器 -->
			<div class="vip-dialog">
				<!-- 顶部信息栏 -->
				<div class="vip-header">
					<div class="vip-user-info" v-if="userInfo">
						<img class="vip-avatar" v-if="userInfo.avatar" :src="userInfo.avatar" alt="头像" />
						<img class="vip-avatar" v-else src="@/assets/images/avatar.png" alt="头像" />
						<span class="vip-account" v-if="userInfo.phone">账户：{{maskPhoneNumber(userInfo.phone)}}</span>
						<span class="vip-divider">|</span>
						<span class="vip-selected">已选：{{headuser.province_name||''}} | {{headuser.subject||''}} |
							{{headuser.score||''}}分</span>

					</div>
					<i class="el-icon-close vip-close" @click="closeDialog"></i>
				</div>
				<div class="vip-main flex-betweenStart" v-loading="loading">
					<div class="vip-main-left">
						<div class="vip-title-wrap">
							<h2 class="vip-title">开通会员 立享至尊权益</h2>
						</div>

						<!-- 推荐志愿统计 - 骨架屏 -->
						<div class="vip-stat-wrap" v-if="loading && !displayNumber.volunteer_nums">
							<div class="skeleton-stat-item">
								<div class="skeleton-line w-120"></div>
								<div class="skeleton-tags">
									<div class="skeleton-tag"></div>
									<div class="skeleton-tag"></div>
									<div class="skeleton-tag"></div>
								</div>
							</div>
						</div>
						<!-- 推荐志愿统计 - 实际内容 -->
						<div class="vip-stat-wrap" v-else-if="displayNumber.volunteer_nums">
							<div class="vip-stat-item">
								<span class="vip-stat-label">解锁</span>
								<span class="vip-stat-num">{{displayNumber.volunteer_nums}}</span>
								<span class="vip-stat-label">个推荐志愿</span>
							</div>
							<div class="vip-stat-tags">
								<span class="vip-tag vip-tag-rush">{{displayNumber.rush}}可冲击</span>
								<span class="vip-tag vip-tag-stable">{{displayNumber.stable}}较稳妥</span>
								<span class="vip-tag vip-tag-safe">{{displayNumber.safe}}可保底</span>
							</div>
						</div>

						<!-- 权益标签栏 -->
						<div class="vip-tabs">
							<div class="vip-tab-item" :class="current === 0 ? 'active' : ''" @click="changeVip(0)">
								VIP会员权益
							</div>
							<div class="vip-tab-item" :class="current === 1 ? 'active' : ''" @click="changeVip(1)">
								SVIP会员权益
							</div>
							<div class="vip-tab-item" :class="current ===2 ? 'active' : ''" @click="changeVip(2)">
								激活会员卡
							</div>
						</div>

						<!-- 权益内容区 - 骨架屏 -->
						<div class="vip-benefits" v-if="loading && !currentInfo">
							<div class="skeleton-benefit-item" v-for="i in 3" :key="i">
								<div class="skeleton-line w-200"></div>
								<div class="skeleton-line w-300 mt-8"></div>
							</div>
						</div>
						<!-- 权益内容区 - 实际内容 -->
						<div class="vip-benefits" v-else>
							<div class="vip-benefit-item">
								<div v-html="currentInfo?.content"></div>
							</div>
						</div>
					</div>

					<!-- 右侧价格区 - 骨架屏 -->
					<div class="vip-price-panel" v-if="loading && !currentPayInfo">
						<div class="skeleton-line w-150"></div>
						<div class="skeleton-line w-120 mt-8"></div>
						<div class="skeleton-price mt-16"></div>
						<div class="skeleton-qrcode mt-16"></div>
					</div>
					<!-- 右侧价格区 - 实际内容 -->
					<div class="vip-price-panel" v-else>
						<div class="vip-price-title">{{currentInfo?.name}}</div>
						<div class="vip-price-expire">有效期至 {{currentInfo?.end_time}}</div>
						<div>
							<div class="vip-price-wrap">
								<span class="vip-price-symbol">¥</span>
								<span class="vip-price-num">{{currentInfo?.price || 0}}</span>
								<span class="vip-price-original">¥{{Number(currentInfo?.price || 0) + 100}}</span>
							</div>
							<div class="vip-qrcode-box">
								<div class="vip-qrcode-placeholder flex-center">
									<div class="flex-center font18 color-orange" v-if="isCurrentVip">
										您已是{{current === 0 ? 'VIP' : 'SVIP'}}
									</div>
									<img v-else-if="currentPayInfo?.qr_code" class="pay-code"
										:src="'data:image/png;base64,' + currentPayInfo.qr_code" alt="" />
									<div v-else class="flex-center font14 color-gray">加载中...</div>
								</div>
								<div v-if="!isCurrentVip && currentPayInfo?.order_no" class="vip-countdown">
									<span class="vip-countdown-label">支付剩余时间</span>
									<span class="vip-countdown-time">{{countdownText}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import bus from '@/utils/bus'
	import {
		cardList,
		cardPay,
		payStatus
	} from '@/api/user'

	export default {
		name: 'VipBuy',
		props: {
			number: {
				type: Object,
				default: () => ({
					volunteer_nums: 0,
					rush: 0,
					stable: 0,
					safe: 0
				})
			},
		},
		data() {
			return {
				visible: false,
				current: 0, // 0: VIP, 1: SVIP
				headuser: null,
				userInfo: null,
				// 本地展示数据
				displayNumber: {
					volunteer_nums: 0,
					rush: 0,
					stable: 0,
					safe: 0
				},
				// 缓存数据
				vipInfo: null, // VIP 会员信息
				svipInfo: null, // SVIP 会员信息
				vipPayInfo: null, // VIP 支付信息
				svipPayInfo: null, // SVIP 支付信息
				// 请求状态
				loading: true, // 初始为 true，弹窗打开时立即显示加载状态
				// 倒计时相关
				endTime: 0,
				timer: null,
				payTimer: null,
				countdownText: '00 : 15 : 00',
				paying: false,
			}
		},
		computed: {
			// 当前显示的会员信息
			currentInfo() {
				return this.current === 0 ? this.vipInfo : this.svipInfo
			},
			// 当前显示的支付信息
			currentPayInfo() {
				return this.current === 0 ? this.vipPayInfo : this.svipPayInfo
			},
			// 当前是否已支付（用于显示"您已是VIP/SVIP"）
			isCurrentVip() {
				if (this.current === 0) {
					return this.userInfo?.is_vip
				} else {
					return this.userInfo?.is_svip
				}
			}
		},
		created() {
			// 监听显示登录弹窗的全局事件
			bus.$on('showVipbuy', async (numberData) => {
				// 先打开弹窗，显示加载状态
				this.visible = true
				this.loading = true

				// 获取基础数据（同步获取，无等待）
				this.headuser = JSON.parse(localStorage.getItem('headuser') || '{}')
				this.userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

				// 重置状态
				this.vipInfo = null
				this.svipInfo = null
				this.vipPayInfo = null
				this.svipPayInfo = null

				// 设置展示数据（如果有传入）
				if (numberData && Object.keys(numberData).length > 0) {
					this.displayNumber = {
						...this.displayNumber,
						...numberData
					}
				} else if (this.number && Object.keys(this.number).length > 0) {
					this.displayNumber = {
						...this.displayNumber,
						...this.number
					}
				}

				// 根据用户已开通的会员设置默认选中的 tab
				if (this.userInfo?.is_svip) {
					this.current = 1 // 已是 SVIP，显示 SVIP
				} else if (this.userInfo?.is_vip) {
					this.current = 1 // VIP 用户默认显示 SVIP（升级）
				} else {
					this.current = 0 // 非会员显示 VIP
				}

				// 异步加载数据（不阻塞弹窗显示）
				try {
					await this.loadData()
				} catch (err) {
					console.error('加载会员数据失败:', err)
				} finally {
					this.loading = false
				}
			})
		},
		beforeDestroy() {
			// 销毁事件监听，避免内存泄漏
			bus.$off('showVipbuy')
			// 清除倒计时定时器
			this.clearAllTimers()
		},
		methods: {
			maskPhoneNumber(phone) {
				if (!phone || phone.length !== 11) return phone;
				return phone.substring(0, 3) + '****' + phone.substring(7);
			},

			clearAllTimers() {
				this.clearTimer()
				this.clearPayTimer()
			},

			clearTimer() {
				if (this.timer) {
					clearInterval(this.timer)
					this.timer = null
				}
			},

			clearPayTimer() {
				if (this.payTimer) {
					clearInterval(this.payTimer)
					this.payTimer = null
				}
			},

			// 加载数据（并发请求）
			async loadData() {
				// 并发请求 VIP 和 SVIP 的卡信息，减少等待时间
				const vipPromise = this.fetchCardData(1).catch(err => {
					console.error('获取VIP信息失败:', err)
					return null
				})
				const svipPromise = this.fetchCardData(2).catch(err => {
					console.error('获取SVIP信息失败:', err)
					return null
				})

				await Promise.all([vipPromise, svipPromise])

				// 如果当前选中项需要支付信息且用户未开通该会员，获取支付信息
				const needPayInfo = this.current === 0 ?
					(!this.vipPayInfo && !this.userInfo?.is_vip) :
					(!this.svipPayInfo && !this.userInfo?.is_svip)

				if (needPayInfo) {
					const cardType = this.current === 0 ? 1 : 2
					await this.fetchPayInfo(cardType)
				}

				// 启动支付相关逻辑
				if (!this.isCurrentVip && this.currentPayInfo?.order_no) {
					this.paying = true
					this.startCountDown()
					this.startPayStatusPolling()
				}
			},

			// 获取会员卡信息
			async fetchCardData(type) {
				try {
					const res = await cardList({
						type
					})
					if (type === 1) {
						this.vipInfo = res.data
					} else {
						this.svipInfo = res.data
					}
					return res.data
				} catch (err) {
					// console.log('获取会员信息失败，请重试')
					this.$message?.error?.('获取会员信息失败，请重试')
					throw err
				}
			},

			// 获取支付信息
			async fetchPayInfo(cardType) {
				const cardInfo = cardType === 1 ? this.vipInfo : this.svipInfo
				if (!cardInfo) {
					console.warn('卡信息不存在，无法获取支付信息')
					return
				}

				try {
					const res = await cardPay({
						province_id: this.headuser?.province_id,
						card_type: cardInfo.id
					})

					if (cardType === 1) {
						this.vipPayInfo = res.data
					} else {
						this.svipPayInfo = res.data
					}

					return res.data
				} catch (err) {
					console.log('获取支付信息失败，请重试')
					// this.$message?.error?.('获取支付信息失败，请重试')
					throw err
				}
			},

			// 切换会员类型
			async changeVip(val) {
				// 激活会员卡，点击后，跳转我的订单页面
				if (val == 2) {
					this.visible = false
					this.paying = false
					this.clearAllTimers()
					this.closeDialog()
					this.$toPage('user/vip')
				} else {

					if (this.current === val) return

					// 清理当前支付相关的定时器
					this.clearAllTimers()
					this.paying = false

					// 切换选中的 tab
					this.current = val

					// 显示加载状态
					this.loading = true

					try {
						// 如果切换后的支付信息不存在且用户未开通该会员，则获取支付信息
						const needPayInfo = this.current === 0 ?
							(!this.vipPayInfo && !this.userInfo?.is_vip) :
							(!this.svipPayInfo && !this.userInfo?.is_svip)

						if (needPayInfo) {
							const cardType = this.current === 0 ? 1 : 2
							await this.fetchPayInfo(cardType)
						}

						// 重新启动支付逻辑
						if (!this.isCurrentVip && this.currentPayInfo?.order_no) {
							this.paying = true
							this.startCountDown()
							this.startPayStatusPolling()
						}
					} catch (err) {
						console.error('切换会员失败:', err)
					} finally {
						this.loading = false
					}
				}
			},

			// 启动支付状态轮询
			startPayStatusPolling() {
				this.clearPayTimer()

				// 立即执行一次
				this.getPayStatus()

				this.payTimer = setInterval(() => {
					if (this.paying && this.currentPayInfo?.order_no) {
						this.getPayStatus()
					} else if (!this.paying) {
						this.clearPayTimer()
					}
				}, 3000)
			},

			getPayStatus() {
				if (!this.currentPayInfo?.order_no || !this.paying) {
					return
				}
				payStatus({
						order_no: this.currentPayInfo.order_no
					})
					.then(res => {
						if (res.data.pay_status) {
							this.paying = false
							this.clearAllTimers()
							// 如果是购买了svip 
							if (this.current == 1) {
								this.closeDialog()
								this.$confirm('是否前往录入成绩', '支付成功', {
									confirmButtonText: '前往',
									cancelButtonText: '取消',
									type: 'success'
								}).then(() => {
									this.$router.push('/user/score')
								}).catch(err => {
									// setTimeout(() => {
									// 全部重新加载
									// window.location.reload()
									// 回首页
									window.location.href = '/';
									// }, 300)
								})
							} else {
								this.$message.success('支付成功')
								window.location.href = '/';
								// 
							}
						}
					})
					.catch(err => {
						console.error('查询支付状态失败:', err)
					})
			},

			// 开始15分钟倒计时
			startCountDown() {
				this.clearTimer()
				const total = 15 * 60
				this.endTime = Date.now() + total * 1000

				this.timer = setInterval(() => {
					const now = Date.now()
					const diff = this.endTime - now

					if (diff <= 0) {
						this.countdownText = '00 : 00 : 00'
						this.clearTimer()
						this.clearPayTimer()
						this.paying = false
						this.$message?.warning?.('支付已超时，请重新获取')
						return
					}

					let m = Math.floor(diff / 1000 / 60 % 60)
					let s = Math.floor(diff / 1000 % 60)
					m = m < 10 ? '0' + m : m
					s = s < 10 ? '0' + s : s
					this.countdownText = `00 : ${m} : ${s}`
				}, 1000)
			},

			closeDialog() {
				this.clearAllTimers()
				this.paying = false
				this.visible = false
				this.$emit('close')
			}
		}
	}
</script>

<style lang="scss" scoped>
	// 遮罩层
	.vip-mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		align-items: center;
		justify-content: center;
		z-index: 9999;
	}

	// 弹窗容器
	.vip-dialog {
		width: 1000px;
		height: 600px;
		background-color: #fff;
		border-radius: 30px;
		overflow: hidden;
		position: relative;
	}

	// 顶部信息栏
	.vip-header {
		height: 110px;
		background: url('/src/assets/images/vipbuy.png') 100% / cover no-repeat;
		padding: 15px 24px;
		display: flex;
		align-items: start;
		justify-content: space-between;

		.vip-user-info {
			display: flex;
			align-items: center;
			color: #333;
			font-size: 16px;

			.vip-avatar {
				width: 32px;
				height: 32px;
				border-radius: 50%;
				margin-right: 12px;
			}

			.vip-divider {
				margin: 0 8px;
				color: #999;
			}

			.vip-edit-icon {
				margin-left: 8px;
				color: #999;
				cursor: pointer;
			}
		}

		.vip-crown {
			position: absolute;
			right: 80px;
			top: 12px;

			img {
				width: 64px;
				height: 64px;
			}
		}

		.vip-close {
			font-size: 20px;
			color: #666;
			cursor: pointer;
		}
	}


	.vip-main {
		background-color: #fff;
		border-radius: 20px 20px 0 0;
		margin-top: -75px;
		padding: 28px;
		min-height: 450px;

		// 左侧
		.vip-main-left {
			width: 640px;

			// 标题区
			.vip-title-wrap {
				padding-bottom: 16px;
				display: flex;
				align-items: center;

				.vip-title {
					font-size: 28px;
					font-weight: 600;
					color: #8B4513;
					margin: 0;
				}

				.vip-tip {
					font-size: 16px;
					color: #999;
					margin-left: 12px;
					cursor: pointer;
				}
			}

			// 推荐志愿统计
			.vip-stat-wrap {
				margin-bottom: 20px;
				padding: 16px 20px;
				border: 1px solid #EBEEF5;
				border-radius: 12px;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.vip-stat-item {
					display: flex;
					align-items: baseline;
					font-size: 18px;
					color: #333;

					.vip-stat-num {
						font-size: 28px;
						font-weight: 600;
						color: #333;
						margin: 0 4px;
					}
				}

				.vip-stat-tags {
					display: flex;
					gap: 12px;

					.vip-tag {
						padding: 6px 16px;
						border-radius: 6px;
						font-size: 16px;
						font-weight: 500;

						&.vip-tag-rush {
							background: #FFF2E8;
							color: #FF6B35;
						}

						&.vip-tag-stable {
							background: #E8F3FF;
							color: #2F74D1;
						}

						&.vip-tag-safe {
							background: #E8FBF7;
							color: #27AE90;
						}
					}
				}
			}

			// 权益标签栏
			.vip-tabs {
				display: flex;
				border-bottom: 1px solid #E5E5E5;

				.vip-tab-item {
					padding: 12px 24px;
					font-size: 20px;
					color: #333;
					cursor: pointer;
					border-bottom: 3px solid transparent;

					&.active {
						color: #B35B22;
						border-bottom-color: #B35B22;
						font-weight: 600;
					}
				}
			}

			// 权益内容区
			.vip-benefits {
				margin: 24px 0 0;
				padding: 20px;
				background: #FFF9F0;
				border-radius: 12px;
				vertical-align: top;
				min-height: 180px;

				.vip-benefit-item {
					margin-bottom: 16px;
					font-size: 16px;

					.vip-benefit-title {
						color: #B35B22;
						font-weight: 600;
					}

					.vip-benefit-desc {
						color: #666;
					}
				}
			}
		}

		// 右侧价格面板
		.vip-price-panel {
			width: 250px;
			display: inline-block;
			vertical-align: top;
			padding: 15px;
			background: #F7F8FA;
			border-radius: 12px;
			min-height: 380px;

			.vip-price-title {
				font-size: 18px;
				font-weight: 600;
				color: #333;
				margin-bottom: 8px;
			}

			.vip-price-expire {
				font-size: 16px;
				color: #FF6B35;
				margin-bottom: 16px;
			}

			.vip-price-wrap {
				display: flex;
				align-items: baseline;
				margin-bottom: 20px;

				.vip-price-symbol {
					font-size: 20px;
					color: #FF6B35;
				}

				.vip-price-num {
					font-size: 36px;
					font-weight: 700;
					color: #FF6B35;
				}

				.vip-price-original {
					font-size: 16px;
					color: #999;
					text-decoration: line-through;
					margin-left: 8px;
				}
			}

			.vip-qrcode-box {
				padding: 22px;
				background: #fff;
				border-radius: 12px;

				.vip-qrcode-placeholder {
					background: url('/src/assets/images/code.png') 100% / cover no-repeat;
					width: 196px;
					height: 196px;
					margin-bottom: 20px;
					display: flex;
					align-items: center;
					justify-content: center;

					.pay-code {
						width: 176px;
						height: 176px;
					}
				}
			}

			.vip-countdown {
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 14px;
				color: #999;

				.vip-countdown-time {
					color: #333;
					font-weight: 500;
				}
			}
		}
	}

	// 骨架屏样式
	.skeleton-stat-item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;

		.skeleton-tags {
			display: flex;
			gap: 12px;
		}

		.skeleton-tag {
			width: 80px;
			height: 36px;
			background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
			background-size: 200% 100%;
			animation: skeleton-loading 1.5s infinite;
			border-radius: 6px;
		}
	}

	.skeleton-line {
		height: 20px;
		background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
		background-size: 200% 100%;
		animation: skeleton-loading 1.5s infinite;
		border-radius: 4px;

		&.w-120 {
			width: 120px;
		}

		&.w-150 {
			width: 150px;
		}

		&.w-200 {
			width: 200px;
		}

		&.w-300 {
			width: 300px;
		}

		&.mt-8 {
			margin-top: 8px;
		}

		&.mt-16 {
			margin-top: 16px;
		}
	}

	.skeleton-price {
		width: 120px;
		height: 44px;
		background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
		background-size: 200% 100%;
		animation: skeleton-loading 1.5s infinite;
		border-radius: 4px;
	}

	.skeleton-qrcode {
		width: 196px;
		height: 196px;
		background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
		background-size: 200% 100%;
		animation: skeleton-loading 1.5s infinite;
		border-radius: 12px;
	}

	.skeleton-benefit-item {
		margin-bottom: 16px;
	}

	@keyframes skeleton-loading {
		0% {
			background-position: 200% 0;
		}

		100% {
			background-position: -200% 0;
		}
	}
</style>